var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3722 30.065C12.2174 30.065 8.84658 26.6942 8.84658 22.5394V4.3526C8.84658 3.33352 9.63049 2.47121 10.728 2.47121H41.4574C46.9448 2.47121 51.4915 7.01791 51.4915 12.5053C51.4915 18.0711 46.9448 22.5394 41.4574 22.5394H38.9489C38.9489 26.6942 35.578 30.065 31.4233 30.065H16.3722ZM41.4574 7.48826H38.9489V17.5224H41.4574C44.2011 17.5224 46.4744 15.3274 46.4744 12.5053C46.4744 9.76161 44.2011 7.48826 41.4574 7.48826ZM45.1418 37.5906H5.08379C1.321 37.5906 0.301915 32.5735 2.2617 32.5735H47.9639C49.9237 32.5735 48.9046 37.5906 45.1418 37.5906Z",
    fill: "#183864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeIcon);
export default __webpack_public_path__ + "static/media/coffeeIcon.844c9e820b16cab37fc9b98ca35996ba.svg";
export { ForwardRef as ReactComponent };